module.exports = __webpack_public_path__ + "img/fig9.27.cff66b61.png";